import { z } from 'zod';

import {
	USER_ID_MAX_LENGTH,
	USER_ID_MIN_LENGTH,
	UUID_SCHEMA,
} from '../../../../../../const/zod/zod';
import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';
import { validateDateRange } from '../../../../../../helpers/zod/validateDateRange';
import { ExtendedEventType } from '../../../const';

export type EventsFilterMessages = {
	dateCantBeEarlierThanBankInceptionDateError: string;
	dateMustBeTodayAtLatestError: string;
	dateToMustBeBeforeDateFromError: string;
};

export const getEventsFilterFormSchema = (
	errorMessages?: EventsFilterMessages,
) => {
	const schema = z
		.object({
			eventType: z.enum(ExtendedEventType).nullable(),
			affectedPidUuid: UUID_SCHEMA.nullable(),
			userPidUuid: UUID_SCHEMA.nullable(),
			userId: z
				.string()
				.min(USER_ID_MIN_LENGTH)
				.max(USER_ID_MAX_LENGTH)
				.nullable(),
			dateFromInclusive: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
			}),
			dateToExclusive: createDateSchemaWithDefinedMinAndMaxBankValues({
				minDateErrorMessage:
					errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
				maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
			}),
		})
		.superRefine(({ dateFromInclusive, dateToExclusive }, ctx) => {
			validateDateRange(
				dateFromInclusive,
				dateToExclusive,
				errorMessages?.dateToMustBeBeforeDateFromError,
				ctx,
				'dateToExclusive',
			);
		});

	return schema;
};

export type EventsFilterForm = z.infer<
	ReturnType<typeof getEventsFilterFormSchema>
>;
